module.exports = __webpack_public_path__ + "static/media/logo_black.7d9816be.svg";